import React, { createRef, useContext, useState } from 'react'
import { updateAdminPassword, uploadLogo } from '../services/adminServices';
import { Cropper } from 'react-cropper';
import { AppContext } from '../context/AppContext';
import { CONFIG } from '../config/general';
import moment from 'moment';
import { toast } from 'react-toastify';

const Settings = () => {
  const { login, appData } = useContext(AppContext);
  const cropperRef = createRef();
  const [newPassword, setNewPassword] = useState("");
  const [logoModal, setLogoModal] = useState(false);
  const [passwordModal, setPasswordModal] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [logo, setLogo] = useState(null)
  const [error, setError] = useState("");

  const handleChangePassword = async () => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
    if (!currentPassword) {
      setError("Current password must be there.");
      return;
    }
    if (!regex.test(newPassword)) {
      setError("Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.");
      return;
    }
    if (currentPassword == newPassword) {
      setError("Current password and new password must not be same.");
      return;
    }
    if (newPassword.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      let result = await updateAdminPassword(login.token, { newPassword, confirmPassword, currentPassword })
      if (result.success) {
        toast.success(result.message)
        setNewPassword("")
        setCurrentPassword("")
        setConfirmPassword("")
        setPasswordModal(false)
      } else {
        toast.error(result.message)
      }
    } catch (error) {
      console.error("Error changing password:", error);
      setError("An error occurred. Please try again.");
    }
  };

  const handleLogoChange = (e) => {
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setLogo(reader.result)
    };
    reader.readAsDataURL(files[0]);
  };

  const onCrop = () => {
    const cropper = cropperRef.current?.cropper;
    if (cropper) {
      const cropBoxData = cropper.getCropBoxData();
      const cropWidth = cropBoxData.width;
      const cropHeight = cropBoxData.height;
      if (cropWidth < 100 || cropHeight < 100) {
        let newCropWidth = Math.max(cropWidth, 100);
        let newCropHeight = Math.max(cropHeight, 100);
        cropper.setCropBoxData({ width: newCropWidth, height: newCropHeight });
      }
    }
  };

  const uploadUpdatedLogo = async (e) => {
    try {
      e.preventDefault();
      const formData = new FormData();
      const cropper = cropperRef.current?.cropper;
      if (cropper) {
        cropper.getCroppedCanvas().toBlob(async (blob) => {
          const croppedFile = new File([blob], "profile-pic.png", { type: "image/png" });
          formData.append(`logoFile`, croppedFile);
          const result = await uploadLogo(login.token, formData)
          setLogo(null)
          if (result.success) {
            toast.success(result.message)
            setLogoModal(false)
          } else {
            toast.error(result.message)
          }
        })
      }
    } catch (error) {
      console.log(error)
    }
  }
  return (
    <div className="details-table mt-3">
      <div className="container my-5">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-8 col-sm-10">
            <div className="text-center mb-4">
              <div>
                <div>
                  <img
                    src={CONFIG.REACT_APP_UPLOADS + "/Icons/logo.png"}
                    alt="Profile Picture"
                    width="150"
                    height="150"
                    id="profile-pic"
                    onError={(e) => {
                      e.target.onerror = null; // Prevents infinite loop if the fallback also fails
                      e.target.src = "./assets/images/logo.png"; // Set the fallback image
                    }}
                  />
                </div>
                <div className='d-flex gap-2 justify-content-center'>
                  <div className="text-center">
                    <button
                      className="submit mt-3 p-3 settingButton"
                      style={{ border: "none" }}
                      onClick={() => setLogoModal(true)}
                    >
                      Upload New Logo
                    </button>
                  </div>
                  <div className="text-center">
                    <button
                      className="submit mt-3 p-3 settingButton"
                      style={{ border: "none", backgroundColor: "red" }}
                      onClick={() => setPasswordModal(true)}
                    >
                      Change Password
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="card" style={{ background: "var(--card-background)" }}>
              <div className="card-header">
                <h5>Company Details</h5>
              </div>
              <div className="card-body">
                <p><strong>Company Name:</strong> {appData.name}</p>
                <p><strong>Company Address:</strong> {appData.address}</p>
                <p><strong>Company Email:</strong> {appData.email}</p>
                <p><strong>Expiry Date:</strong> {moment(appData.expiryDate).format("DD-MMM-YYYY")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {logoModal && <div
        className="modal d-block show"
        id="uploadLogo"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="uploadLogoLabel">
                Upload Logo
              </h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => setLogoModal(false)}
              ></button>
            </div>
            <div className="modal-body">
              <form id="logoUploadForm" onSubmit={uploadUpdatedLogo}>
                <div className="mb-3">
                  <label htmlFor="logoFile" className="form-label">
                    Upload Logo
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    id="logoFile"
                    accept="image/*"
                    onChange={handleLogoChange}
                    required
                  />
                  {logo && <Cropper
                    ref={cropperRef}
                    src={logo}
                    style={{ width: '100%', height: '100%' }}
                    viewMode={1}
                    crop={onCrop}
                    minCropBoxWidth={100}
                    minCropBoxHeight={100}
                    background={false}
                    responsive={true}
                    autoCropArea={1}
                    checkOrientation={false}
                    guides={true}
                  />}
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => setLogoModal(false)}
              >
                Close
              </button>
              <button
                type="submit"
                form="logoUploadForm"
                className="btn btn-primary"
              >
                Upload
              </button>
            </div>
          </div>
        </div>
      </div>}
      {passwordModal && <div
        className="modal d-block show"
        id="changePasswordModal"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="changePasswordModalLabel">
                Change Password
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setPasswordModal(false)}
              ></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label htmlFor="currentPassword" className="form-label">
                  Current Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="currentPassword"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="newPassword" className="form-label">
                  New Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="newPassword"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="confirmPassword" className="form-label">
                  Confirm Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
              {error && <p className="text-danger">{error}</p>}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setPasswordModal(false)}
                id="closeChangePasswordModal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleChangePassword}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>}
    </div>
  )
}

export default Settings
